import { atom } from 'recoil';

import { addRecoilKey } from '../../../utils/recoil';

export const showGlobalOverlayAtom = atom<boolean>({
  key: addRecoilKey('global-show-overlay'),
  default: false,
});
